export enum AirlinePolicyEnum {
  INCLUDED = 'INCLUDED',
  EXCLUDED = 'EXCLUDED',
}
